module.exports = __webpack_public_path__ + "img/Saint Pierre and Miquelon.757a3260.svg";